// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
// import Swiper and modules styles
import 'swiper/css/bundle';


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * Swiper function
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
var topHeroSlider = new Swiper('.topHeroSlider', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  speed: 2000,
  preloadImages: false,

  grabCursor: true,
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".topHeroSlider .swiper-button-next",
    prevEl: ".topHeroSlider .swiper-button-prev",
  },

  slidesPerView: 1, // or 'auto'
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },

});



